/**
 * Cooldown por tipo de evento após falha.
 */

import type { SendEventParams } from '../../utils/sendEvent';
import { classifyRetry } from './retryClassifier';

const COOLDOWN_MS: Record<ReturnType<typeof classifyRetry>, number> = {
  critical: 500,
  medium: 2000,
  low: 5000,
};

const lastFailureByType = new Map<string, number>();

export function getCooldownMs(eventType: SendEventParams['type']): number {
  return COOLDOWN_MS[classifyRetry(eventType)];
}

export function recordFailureCooldown(eventType: SendEventParams['type']): void {
  lastFailureByType.set(eventType, Date.now());
}

export function getCooldownRemaining(
  eventType: SendEventParams['type'],
  now: number
): number {
  const last = lastFailureByType.get(eventType);
  if (!last) return 0;
  const remaining = getCooldownMs(eventType) - (now - last);
  return Math.max(0, remaining);
}

export function _testResetCooldown(): void {
  lastFailureByType.clear();
}
